import { render, staticRenderFns } from "./mothFreightVolumeEchart.vue?vue&type=template&id=3f4a623e&scoped=true&"
import script from "./mothFreightVolumeEchart.vue?vue&type=script&lang=js&"
export * from "./mothFreightVolumeEchart.vue?vue&type=script&lang=js&"
import style0 from "./mothFreightVolumeEchart.vue?vue&type=style&index=0&id=3f4a623e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4a623e",
  null
  
)

export default component.exports